module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm1-00520aef93f7e657cfc47f0c84dd7b19.jpg";